export default function (state, { id }) {
    let items = state.get('items');

    return state
        .set('items', items.delete(id));
}
